import { TYPES } from '../reducers/autenticacao'

export const setUser = data => ({
  type: TYPES.SET_USER,
  payload: data
})
